//庆贺吧!你发现了宝藏！
let _timerObject = { timer: null };
/**
 * @desc  函数防抖,建议在<el-input>中的input事件中使用,防止频繁向后端发送请求
 * @author tangxy
 * @param {function}func 需要执行的函数
 * @param {Number}wait 延迟执行时间（毫秒）
 * @param {Object}_timerObject[timer] 函数执行所挂载的timer对象,默认挂在到了内置的_timerObject.timer上,也可以设置直接挂载到_timerObject.timer上,当页面内有多个防抖或者节流函数时为防止冲突此为必填项,且一定要挂载到不同的对象上,建议声明一个this.timers{}对象来储存不同的timer对象。
 * @param {Boolean}immediate true 立即执行模式,false 非立即执行模式,默认false
 * @return 返回函数立即执行
 **/
export const debounce = (func, wait, timer = "timer", immediate = false) => {
  console.log("防抖开始", timer);
  console.log(_timerObject.hasOwnProperty(timer));
  if (_timerObject.hasOwnProperty(timer) == false) {
    _timerObject[timer] = null;
  }
  console.log("_timerObject", _timerObject);
  return (function () {
    console.log("函数开始", _timerObject[timer]);
    let context = this;
    let args = arguments;
    if (_timerObject[timer]) {
      console.log("检测到timer");
      clearTimeout(_timerObject[timer]);
    } else {
      console.log("没有timer");
    }
    if (immediate == true) {
      let callNow = !_timerObject[timer];
      _timerObject[timer] = setTimeout(() => {
        _timerObject[timer] = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      _timerObject[timer] = setTimeout(() => {
        func.apply(context, args);
      }, wait);
      console.log("防抖结束", _timerObject[timer]);
    }
  })();
};
/**
 * @desc  函数节流懂得都懂,防止频繁向后端发送请求
 * @author tangxy
 * @param {function} fn 需要执行的函数
 * @param {Number} wait 限制执行时间（毫秒）
 * @param {Object} _timerObject[timer] 函数执行所挂载的timer对象,默认挂在到了内置的_timerObject.timer上,也可以设置直接挂载到this.timer上,当页面内有多个防抖或者节流函数时为防止冲突此为必填项,且一定要挂载到不同的对象上,建议声明一个this.timers{}对象来储存不同的timer对象。
 * @param  {Boolean} immediate---true 表计时器方式,false 表时间戳方式,默认true
 * @returns 返回函数立即执行
 */
export const throttle = (fn, wait, timer = _timerObject.timer, immediate = true) => {
  console.log("节流开始");
  if (_timerObject.hasOwnProperty(timer) == false) {
    _timerObject[timer] = null;
  }
  if (immediate) {
    return (function () {
      let context = this;
      let args = arguments;
      if (!_timerObject[timer]) {
        _timerObject[timer] = setTimeout(() => {
          fn.apply(context, args);
          _timerObject[timer] = null;
        }, wait);
      }
    })();
  } else {
    let pre = Date.now();
    return (function () {
      let context = this;
      let args = arguments;
      let now = Date.now();
      if (now - pre >= wait) {
        fn.apply(context, args);
        pre = Date.now();
      }
    })();
  }
};
